import styled from 'styled-components';

export const Container = styled.div`
  th {
    min-width: auto; /* Ajuste o valor conforme necessário */
    white-space: nowrap; /* Impede que o texto quebre em várias linhas */
    text-align: center; /* Centraliza o texto */
  }
`;
